/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
import { DATA_MIGRATION_STARTED, DATA_MIGRATION_READY, DATA_MIGRATION_CONFIRMED } from 'utils/consts/migration';
// utils
// material
// content
import CommentingV2Activated from './commentingv2activated/commentingv2activated';
import MigrateData from './migratedata/migratedata';
import MigrationComplete from './migrationcomplete/migrationcomplete';
// styles
import injectSheet from "react-jss";
import styles from './migrationmodal_styles';

/* ========== ~~~~~~~~~~ MIGRATION MODALS ~~~~~~~~~~ ========== */
const MigrationModal  = injectSheet(styles)((props) => {
  const { migrationStatus } = props


  return (
    <div className={'migrationmodal'}>
     {migrationStatus === DATA_MIGRATION_READY && <CommentingV2Activated />}
     {migrationStatus === DATA_MIGRATION_STARTED && <MigrateData />}
     {migrationStatus === DATA_MIGRATION_CONFIRMED && <MigrationComplete />}
    </div>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default MigrationModal